/**
 * Format a checked-baggage allowance from Amadeus fields.
 * Show what's actually published; never invent values.
 *   - both qty & weight -> "2 × 23kg"
 *   - only qty           -> "2 bag(s)"
 *   - only weight        -> "23kg"
 *   - neither            -> "—"
 */
export function formatCheckedBaggage(qty, kg) {
  const q = Number(qty || 0);
  const w = Number(kg || 0);
  if (q > 0 && w > 0) return `${q} × ${w}kg`;
  if (q > 0) return `${q} bag${q > 1 ? "s" : ""}`;
  if (w > 0) return `${w}kg`;
  return "—";
}

/**
 * Same shape but for the booking-summary line (passenger context).
 * Falls back to a sensible label when ambiguous.
 */
export function formatBaggageLine(bag) {
  if (!bag) return "—";
  const q = Number(bag.qty || bag.quantity || 0);
  const w = Number(bag.kg || bag.weight_kg || 0);
  return formatCheckedBaggage(q, w);
}
